module.exports = __webpack_public_path__ + "img/jiagou.52788d63.png";